import { NewNudge } from '@/models/nudge-config/newNudge';
import { NewNudgeType } from '@/models/nudge-config/newNudgeType';
import { myGooruAPI } from '@/providers/apis/my-gooru/my-gooru';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'create-new-nudge-type',
})
export default class CreateNewNudge extends Vue {
  @Prop()
  private isEdit!: boolean;
  @Prop({ default: undefined })
  private updatingNudge: any;
  @Prop()
  private clearUpdatingNudge!: () => void;
  @Prop()
  private getNudgeTypes!: () => void;

  private isCreated: boolean = false;
  private isUpdated: boolean = false;
  private newNudgeType: NewNudgeType = {
    thumbnail: {
      icon: '',
    },
    title: '',
    description: '',
    key: '',
    conversationText: '',
  };
  private copyOfUpdtingNudge: any = null;
  private nudgeTypeErrorMsg = {
    title: '',
    key: '',
    icon: '',
  };
  private errorObject = {
    existKey: false,
    creationError: false,
    updationError: false,
  };

  private created() {
    if (this.isEdit && this.updatingNudge) {
      this.newNudgeType = this.cloneNudgeDetails(this.updatingNudge);
      this.copyOfUpdtingNudge = this.cloneNudgeDetails(this.updatingNudge);
    }
  }

  private cloneNudgeDetails(updateNudge: any) {
    const nudge: NewNudgeType = {
        thumbnail: {
            icon: this.updatingNudge.thumbnail.icon &&
            this.updatingNudge.thumbnail.icon.replaceAll(
              'https://cdn.gooru.org/',
              '',
            ),
        },
        title: updateNudge.title,
        description: updateNudge.description,
        key: updateNudge.key,
        conversationText: updateNudge.conversationText,
    };
    return nudge;
  }

  private async createNudge(newNudge: NewNudgeType) {
    if (!this.validateNudge(newNudge)) {
      return;
    }

    const payload = this.buildPayload(newNudge);
    const response: any = await myGooruAPI.createNudgeType(payload);

    if (response.success === false) {
      if (response.status === 409) {
        this.errorObject.existKey = true;
      } else {
        this.errorObject.creationError = true;
      }
      return;
    }

    this.isCreated = true;

    setTimeout(() => {
      this.getNudgeTypes();
      this.closePopUp();
      this.isCreated = false;
      this.errorObject.existKey = false;
      this.errorObject.creationError = false;
    }, 1500);
  }

  private async updateNudge(updateNudge: NewNudgeType) {
    if (!this.validateNudge(updateNudge)) {
      return;
    }

    const payload = this.getUpdatedFields(this.copyOfUpdtingNudge, updateNudge);
    const nudgeTypeId = this.updatingNudge.id;
    if (payload && typeof payload === 'object' && !Array.isArray(payload) && Object.keys(payload).length === 0) {
        this.errorObject.updationError = true;
        return;
    }
    const response: any = await myGooruAPI.updateNudgeType(nudgeTypeId, payload);

    if (response.success === false) {
      if (response.status === 409) {
        this.errorObject.existKey = true;
      } else {
        this.errorObject.updationError = true;
      }
      return;
    }

    this.isUpdated = true;

    setTimeout(() => {
      this.getNudgeTypes();
      this.closePopUp();
      this.isUpdated = false;
      this.errorObject.existKey = false;
      this.errorObject.updationError = false;
    }, 1500);
  }

  private closePopUp() {
    this.updatingNudge = '';
    this.clearUpdatingNudge();

    this.$bvModal.hide('create-new-nudge-type');
  }

  private validateNudge(nudge: NewNudgeType): boolean {
    this.nudgeTypeErrorMsg = {
      title: '',
      key: '',
      icon: '',
    };

    let isValid = true;

    if (!nudge.title) {
      this.nudgeTypeErrorMsg.title = 'Title is required';
      isValid = false;
    }

    if (!nudge.key) {
      this.nudgeTypeErrorMsg.key = 'key is required';
      isValid = false;
    }

    if (!nudge.thumbnail.icon) {
      this.nudgeTypeErrorMsg.icon = 'Icon is required';
      isValid = false;
    }

    return isValid;
  }

  private buildPayload(newNudge: NewNudgeType): NewNudgeType {
    const payload: NewNudgeType = {
      title: newNudge.title,
      key: newNudge.key,
      description: newNudge.description ? newNudge.description : null,
      conversationText: newNudge.conversationText
        ? newNudge.conversationText
        : null,
      thumbnail: {
        icon: newNudge.thumbnail.icon,
      },
    };

    return payload;
  }

  private getUpdatedFields(nudge: any, updatingNudge: any) {
    const updatedFields: any = {};
    for (const key in nudge) {
      if (updatingNudge.hasOwnProperty(key)) {
        const newValue = updatingNudge[key];
        const oldValue = nudge[key];
        const isObject = (val: any) => val && typeof val === 'object' && !Array.isArray(val);
        const isArray = (val: any) => Array.isArray(val);
        if (isObject(oldValue) && isObject(newValue)) {
          const nestedChanges: any = this.getUpdatedFields(oldValue, newValue);
          if (Object.keys(nestedChanges).length > 0) {
            updatedFields[key] = nestedChanges;
          }
        } else if (isArray(oldValue) && isArray(newValue)) {
          // Check if arrays are different
          const arraysAreDifferent =
            oldValue.length !== newValue.length ||
            JSON.stringify(oldValue) !== JSON.stringify(newValue);
          if (arraysAreDifferent) {
            updatedFields[key] = newValue;
          }
        } else if (oldValue !== newValue) {
          updatedFields[key] = newValue;
        }
      }
    }
    return updatedFields;
    }
}
